// Sound and vibration for scans: the packer looks at the products, not at the screen.
let audio: AudioContext | null = null;

function tone(context: AudioContext, frequency: number, start: number, duration: number) {
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = 'square';
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0.08, context.currentTime + start);
  gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + start + duration);
  oscillator.connect(gain).connect(context.destination);
  oscillator.start(context.currentTime + start);
  oscillator.stop(context.currentTime + start + duration + 0.02);
}

/** warn: done, but look before going on (packed with fewer labels than it may need) */
export function feedback(kind: 'ok' | 'error' | 'done' | 'warn'): void {
  try {
    audio ??= new AudioContext();
    if (kind === 'ok') tone(audio, 1046, 0, 0.09);
    if (kind === 'done') {
      tone(audio, 784, 0, 0.1);
      tone(audio, 1175, 0.12, 0.16);
    }
    if (kind === 'error') {
      tone(audio, 196, 0, 0.18);
      tone(audio, 196, 0.24, 0.24);
    }
    if (kind === 'warn') {
      tone(audio, 659, 0, 0.14);
      tone(audio, 440, 0.18, 0.14);
      tone(audio, 659, 0.36, 0.14);
    }
  } catch {
    // no audio device: the colour flash is enough
  }
  navigator.vibrate?.(kind === 'error' || kind === 'warn' ? [120, 80, 120] : 40);
}

/**
 * A browser keeps a page silent until someone touches it: the first tap or key on any screen readies the
 * sound, so an acil iş arriving later is heard even on a screen nobody scanned on yet.
 */
export function primeAudio(): void {
  try {
    audio ??= new AudioContext();
    if (audio.state === 'suspended') void audio.resume();
  } catch {
    // no audio device
  }
}

/** A new acil iş (the red bar): a siren-like rise twice, unlike any scan's answer. The device's mute switch silences it. */
export function urgentSiren(): void {
  try {
    audio ??= new AudioContext();
    if (audio.state === 'suspended') void audio.resume();
    for (const start of [0, 0.5]) {
      tone(audio, 880, start, 0.14);
      tone(audio, 1318, start + 0.16, 0.14);
      tone(audio, 1760, start + 0.32, 0.12);
    }
  } catch {
    // no audio device: the red bar is enough
  }
}

/** A new acil iş on a phone: a long buzz, muted or not (the switch is the sound's; a phone in a pocket still feels it). */
export function urgentBuzz(): void {
  navigator.vibrate?.([300, 120, 300, 120, 300]);
}
